export default function getResource(label) {
    const resources = {
        getFreeSameDayDelivery: 'Profitez de la livraison GRATUITE le jour même',
        getFreeSameDayDeliverySMUI: 'Profitez de la livraison {color:red}GRATUITE{color} le jour même',
        tryNowForFree: 'Essayez-la gratuitement',
        signUp: 'S’inscrire',
        startSavingWithSDU: 'Commencez à économiser avec la livraison le jour même illimitée de Sephora.',
        startSaving: 'Commencez à économiser avec un *essai GRATUIT de 30 jours* pour la livraison le jour même illimitée de Sephora.'
    };

    return resources[label];
}
